import React, { useEffect, useState } from "react";
import SiteMap from "../components/SiteMap";
import { ColorScheme } from "../components/SiteMap";
import { useLocation } from "react-router-dom";

import { AuctionHeader } from "../components/auctions/header";
import AuctionDetails from "../components/auctions/listing/AuctionDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAuctionData,
  resetAuctionData,
} from "../Redux/AuctionData/AuctionsDataSlice";

import { getTimeStatus } from "../helper/timeUtils";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";

export default function AuctionDetailsPage({ data }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const dispatch = useDispatch();
  const auctionData = useSelector((state) => state.auction.auctionData);
  const auctionHorses = useSelector((state) => state.auction.auctionHorses);
  const auctionAttachment = useSelector(
    (state) => state.auction.auctionAttachment
  );
  const { translate } = useTranslate();

  // get auction data
  const currentAuctionId = searchParams.has("id")
    ? searchParams.get("id")
    : null;

  useEffect(() => {
    dispatch(resetAuctionData());
  }, []);
  useEffect(() => {
    dispatch(fetchAuctionData(currentAuctionId));
  }, [dispatch, currentAuctionId]);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [bidderId, setBidderId] = useState("");
  const [bidderNumber, setBidderNumber] = useState(0);
  async function getPaymentStatus(
    paymentStatus = "",
    bidderId = "",
    bidderNumber = ""
  ) {
    setPaymentStatus(paymentStatus);
    setBidderId(bidderId);
    setBidderNumber(bidderNumber);
    if (!!auctionData) {
      localStorage.setItem(`${auctionData.auuctionId}`, paymentStatus);
    }
    return paymentStatus;
  }

  return (
    <>
    {!!!auctionData && <Loader />}
      {!!auctionData && (
        <>
          <AuctionHeader
            slider={auctionAttachment}
            details={auctionData}
            getPaymentStatus={getPaymentStatus}
            paymentStatus={paymentStatus}
            auctionHorses={auctionHorses}
            bidderId={bidderId}
            bidderNumber={bidderNumber}
          />
        </>
      )}
      {!!auctionData && (
        <>

        <AuctionDetails
          auctionData={auctionData}
          auctionHorses={auctionHorses}
          paymentStatus={paymentStatus}
          bidderId={bidderId}
          bidderNumber={bidderNumber}
          currentAuctionId={currentAuctionId}
        />
        </>

      )}
    </>
  );
}
